import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Physiotherapy from '@/pages/home/components/Physiotherapy';

export default function PhysiotherapyPage() {
  return (
    <div className="min-h-screen bg-black">
      <Helmet>
        <title>Physiotherapy at HUB30 | Injury Recovery & Manual Therapy – Jbeil, Lebanon</title>
        <meta
          name="description"
          content="Professional physiotherapy services at HUB30 in Jbeil — injury assessment, manual therapy, and performance recovery. Book a session with our certified specialists."
        />
        <meta
          name="keywords"
          content="physiotherapy Jbeil, physio Lebanon, injury recovery Byblos, manual therapy Lebanon, sports physiotherapy Jbeil, rehabilitation gym Lebanon"
        />
        <link rel="canonical" href="https://hub30gym.com/physiotherapy" />
        <meta property="og:title" content="Physiotherapy at HUB30 | Recovery Specialists – Jbeil, Lebanon" />
        <meta property="og:description" content="Injury assessment, manual therapy, and performance recovery at HUB30 gym in Jbeil, Lebanon. Book a session today." />
        <meta property="og:url" content="https://hub30gym.com/physiotherapy" />
      </Helmet>
      <Navbar />
      <div className="pt-20">
        <Physiotherapy />
      </div>
      <Footer />
    </div>
  );
}
